import React, { Suspense, useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import replace from "../../../assets/images/category/replace.png";
import notFound from "../../../assets/images/common/image-not-found.png";
import Tooltip from "@mui/material/Tooltip";
import ReactImageGallery from "react-image-gallery";
import { Canvas, useThree } from "@react-three/fiber";
import { Bounds, OrbitControls, useGLTF } from "@react-three/drei";
import { PointLight } from "three";
import { Md3dRotation } from "react-icons/md";
import "react-image-gallery/styles/css/image-gallery.css";
import ReactImageMagnify from "react-image-magnify";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import "./imageEnlarge.scss";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const Model = ({ imageUrl, key }) => {
  const { scene } = useGLTF(imageUrl);

  // Clone the scene to avoid sharing between different Canvas instances
  const clonedScene = useMemo(() => scene.clone(), [scene]);
  return (
    <primitive
      key={key} // Force re-render when key changes
      scale={[0.8, 0.8, 0.8]}
      position={[0, -0.5, 0]}
      rotation={[0, Math.PI / 2, 0]}
      object={clonedScene}
    />
  );
};

const ImageEnlarge = ({ isMultiple, setShowReference, imageData }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  // Clean up WebGL resources when modal closes
  const handleModalClose = () => {
    setShowReference({
      ...imageData,
      show: false,
    });
  };

  const handleClick = () => {
    if (
      imageData?.title === "Graphical description" ||
      imageData?.title === "Recommended photography shoot setup" ||
      imageData?.title === "Photo setup"
    ) {
      if (imageData?.ref) {
        imageData?.ref?.click();
      } else {
        document
          .getElementById(`${imageData?.imageIdTitle}-${imageData?.imageIndex}`)
          .click();
      }
    } else if (
      imageData?.title === "Condition assessment" ||
      imageData?.title === "Proposed treatment"
    ) {
      document
        .getElementById(
          `${imageData?.imageIdTitle}-${imageData?.parentIndex}-${imageData?.childIndex}-${imageData?.imageIndex}`
        )
        .click();
    } else if (imageData?.title === "Digital image") {
      if (imageData?.threeDpreview) {
        document.querySelector(".glb-img").click();
      } else {
        document
          .querySelector(`.reference-image-${imageData?.imageIndex}`)
          .click();
      }
    } else if (imageData?.title === "Ledger image") {
      document.querySelector(".ledger-image").click();
    } else if (imageData?.title === "Page image") {
      document.querySelector(".page-image").click();
    } else if (imageData?.title === "Reference image") {
      document.querySelector(".reference-image").click();
    } else if (imageData?.title === "Entry image") {
      document.getElementById(`photo-entry-${imageData?.imageIndex}`).click();
    }
  };

  let multipleImage = [];

  if (Array.isArray(imageData?.image)) {
    const newImage = imageData?.image?.map((li, index) => {
      const isGlb = li?.images?.includes(".glb");
      return {
        original: li?.images || li?.image || li?.entry_image,
        thumbnail: li?.images || li?.image || li?.entry_image,
        //         type: isGlb ? "glb" : "image",
        // uniqueKey: `${isGlb ? "glb" : "image"}-${index}-${Date.now()}`,
      };
    });
    multipleImage = newImage;
  }

  // Render thumbnail for gallery
  // const renderThumbInner = (item) => {
  //     if (item.type === 'glb') {
  //         return (
  //             <div >
  //                 <Canvas
  //                     key={`thumb-${item.uniqueKey}`}
  //                     style={{
  //                         height: '60px',
  //                         width: '60px',
  //                         background: '#f0f0f0',
  //                         cursor: 'pointer'
  //                     }}
  //                     camera={{ position: [0, 0, 5], fov: 45 }}
  //                     gl={{
  //                         preserveDrawingBuffer: true,
  //                         antialias: true,
  //                         alpha: true
  //                     }}
  //                 >
  //                     <ambientLight intensity={0.5} />
  //                     <directionalLight position={[5, 5, 5]} intensity={0.5} />
  //                     <Suspense fallback={null}>
  //                         <Bounds fit clip observe margin={1.2}>
  //                             <Model imageUrl={item.original} key={`thumb-model-${item.uniqueKey}`} />
  //                         </Bounds>
  //                     </Suspense>
  //                 </Canvas>
  //                 <div className='3d-gallery-container' style={{ position: "absolute" }}>
  //                     <Md3dRotation />

  //                 </div>
  //             </div>
  //         );
  //     }

  //     return (
  //         <img
  //             src={item.thumbnail}
  //             alt="thumbnail"
  //             style={{
  //                 width: '60px',
  //                 height: '60px',
  //                 objectFit: 'cover'
  //             }}
  //             onError={(e) => (e.currentTarget.src = notFound)}
  //         />
  //     );
  // };

  // Render main gallery item
  // const renderItem = (item) => {
  //     if (item.type === 'glb') {
  //         console.log(item, "main view mode");

  //         return (
  //             <div>
  //                 <Canvas
  //                     key={`main-${item.uniqueKey}`}
  //                     style={{
  //                         height: '500px',
  //                         background: '#f0f0f0',
  //                         cursor: 'grab'
  //                     }}
  //                     camera={{ position: [0, 0, 5], fov: 45 }}
  //                     gl={{
  //                         preserveDrawingBuffer: true,
  //                         antialias: true,
  //                         alpha: true
  //                     }}
  //                 >
  //                     <ambientLight intensity={0.5} />
  //                     <directionalLight position={[5, 5, 5]} intensity={0.5} />
  //                     <Suspense fallback={null}>
  //                         <Bounds fit clip observe margin={1.2}>
  //                             <Model imageUrl={item.original} key={`main-model-${item.uniqueKey}`} />
  //                         </Bounds>
  //                     </Suspense>
  //                     <OrbitControls enableZoom enablePan enableRotate />
  //                     {/* <CanvasCleanup onUnmount={handleWebGLCleanup} /> */}
  //                 </Canvas>
  //                 <div className='3d-gallery-container' style={{ position: "absolute",top:"18px",right:"23px" }}>
  //                     <Md3dRotation style={{fontSize:"25px"}} />

  //                 </div>
  //             </div>
  //         );
  //     } else {

  //         return (
  //             <img
  //                 src={item.original}
  //                 alt="preview"
  //                 style={{ width: '100%', height: '500px', objectFit: 'contain' }}
  //                 onError={(e) => (e.currentTarget.src = notFound)}
  //             />
  //         );
  //     }
  // };

  return (
    <Modal
      centered
      onHide={handleModalClose}
      show={imageData?.show}
      fullscreen={imageData?.isExpand}
      style={{
        zIndex: "1050",
      }}
      animation={false}
      className={imageData?.threeDpreview ? null : "image-enlarge-modal"}
    >
      <Modal.Header className="detail-view-header " closeButton>
        <Modal.Title>
          <h4 className="modal-title-image-enlarge">{imageData?.title}</h4>
        </Modal.Title>
        {imageData?.isEdit && (
          <Tooltip
            title={imageData?.isExpand ? "Replace .glb file" : "Replace image"}
          >
            <div
              onClick={handleClick}
              style={{ position: "absolute", right: "80px", cursor: "pointer" }}
            >
              <img src={replace} alt="replace-img" />
            </div>
          </Tooltip>
        )}
      </Modal.Header>
      <Modal.Body>
        <div className="preview-img-box">
          <div
            id="zoom-portal"
            style={{
              position: "relative",
              zIndex: 9999,
              border: "1px solid #fff",
            }}
          ></div>
          {Array.isArray(imageData?.image) ? (
            <>
              <Swiper
                style={{
                  "--swiper-navigation-color": "#fff",
                  "--swiper-pagination-color": "#fff",
                }}
                spaceBetween={10}
                slidesPerView={1}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper image-enlarge-swiper-main"
              >
                {imageData?.image.map((item, index) => (
                  <SwiperSlide key={index}>
                    <ReactImageMagnify
                      imageClassName="react-magnify-small"
                      enlargedImageClassName="react-magnify-large"
                      enlargedImageContainerClassName="react-magnify-large-container-swiper"
                      enlargedImagePosition="beside"
                      enlargedImagePortalId="zoom-portal"
                      {...{
                        smallImage: {
                          alt: "Wristwatch by Ted Baker London",
                          isFluidWidth: true,
                          src: item?.images || item?.image || item?.entry_image,
                          onError: (e) => (e.currentTarget.src = notFound),
                        },
                        largeImage: {
                          src: item?.images || item?.image || item?.entry_image,
                          width: 2500,
                          height: 1500,
                        },
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={10}
                freeMode={true}
                watchSlidesProgress={true}
                slidesPerView="auto" // ⭐ allow natural width
                centeredSlides={true} // ⭐ center the slides
                centeredSlidesBounds={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper image-enlarge-swiper-thumbnail"
              >
                {imageData?.image.map((item, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={item?.images || item?.image || item?.entry_image}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          ) : imageData?.threeDpreview ? (
            <Canvas
              key={`single-3d-${imageData?.imageIndex}`}
              style={{ height: "80vh", background: "#f0f0f0" }}
            >
              <ambientLight intensity={3.5} />
              <directionalLight position={[5, 5, 5]} intensity={2.5} />
              <directionalLight position={[-5, 5, -5]} intensity={1.5} />
              <pointLight position={[0, 10, 0]} intensity={2.0} />

              {/* Add additional fill light */}
              <directionalLight position={[0, -5, 0]} intensity={1.0} />
              <Suspense fallback={null}>
                <Bounds fit clip observe={false} margin={1.2}>
                  <Model
                    imageUrl={imageData?.threeDpreview}
                    key={`single-model-${imageData?.imageIndex}`}
                  />
                </Bounds>
              </Suspense>

              <OrbitControls enableZoom enablePan enableRotate />
              {/* <CanvasCleanup onUnmount={handleWebGLCleanup} /> */}
            </Canvas>
          ) : (
            <ReactImageMagnify
              imageClassName="react-magnify-small"
              enlargedImageClassName="react-magnify-large"
              enlargedImageContainerClassName="react-magnify-large-container"
              enlargedImagePosition="beside"
              {...{
                smallImage: {
                  alt: "Wristwatch by Ted Baker London",
                  isFluidWidth: true,
                  src: imageData?.image || "",
                  onError: (e) => (e.currentTarget.src = notFound),
                },
                largeImage: {
                  src: imageData?.image || "",
                  width: 2500,
                  height: 1500,
                },
              }}
            />
          )}
          <div className="preview-hover-icons">
            <div className="preview-delete">
              {/* <img src={deleteIcon} alt='delete-img' onClick={handleDeleteReferImage}/> */}
            </div>
          </div>
        </div>
        <div className="reference-overlay"></div>
      </Modal.Body>
    </Modal>
  );
};

export default ImageEnlarge;
